import Model from 'flarum/common/Model';

export default class LessonPlanActivityType extends Model {
  id = Model.attribute('id');
  title = Model.attribute('title');
  lesson_plans = Model.hasOne('lesson_plans');

  apiEndpoint() {
    return '/lesson-plan-activity-types/' + (this.exists ? '/' + this.data.id : '');
  }
}
